import * as React from 'react';

import {IconButton} from '../../button/icon-button/icon-button';
import {EyeClosedIcon} from '../../icon/svg/eye-closed-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from '../../icon/svg/eye-icon';
import {StackLegacy} from '../../layout/stack/stack-legacy';

import styles from './quote-product-table.module.css';

type Props = {
    title: string;
    showColumn: boolean;
    setColumnState: (arg1: boolean) => void;
    showToggle: boolean;
    isDisabled?: boolean;
};

export function ToggleableColumnHeader(props: Props) {
    return (
        <div className={styles['column-header']}>
            <StackLegacy spacing={2} isHorizontal={true}>
                {props.title}
                {props.showToggle && (
                    <IconButton
                        icon={props.showColumn ? EyeIcon : EyeClosedIcon}
                        noPadding={true}
                        onClick={() =>
                            props.isDisabled ? undefined : props.setColumnState(!props.showColumn)
                        }
                        isDisabled={props.isDisabled}
                        noHoverBackground={props.isDisabled}
                    />
                )}
            </StackLegacy>
        </div>
    );
}
